export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const TENANT_KEY = 'tenantId';
export const LAST_TENANT_KEY = 'lastTenantId';
export const LAST_TENANT_NAME_KEY = 'lastTenantName';
